<!--
 * @Author: ZLZ
 * @Date: 2026-01-12 15:23
 * @LastEditors: ZLZ
 * @Description: 微信一键授权登录弹窗
-->
<template>
  <div class="comContent">
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          v-model="userName"
          name="userName"
          label="账号"
          placeholder="请填写账号"
          :rules="[{ required: true, message: '请填写账号' }]"
        />
        <van-field
          v-model="password"
          type="password"
          name="password"
          label="密码"
          placeholder="请填写密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        />
      </van-cell-group>
      <div class="footerBtn">
        <van-button
          square
          block
          type="primary"
          :color="checked ? 'rgba(248, 15, 57, 1)' : 'rgba(248, 15, 57, 0.6)'"
          native-type="submit"
        > 登录 </van-button>
      </div>
    </van-form>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import CryptoJS from 'crypto-js';
import { loginReq } from "@/assets/js/request/api.js";
import useUsersStore from "@/stores/user";
import useRefreshStore from "@/stores/refresh";
import loginToWebSocket from "@/utils/webSocket/loginToWebSocket";

const props = defineProps({
  checked: {
    type: Boolean,
    default: false,
  }
});
const userStore = useUsersStore();
const refreshStore = useRefreshStore();
const emits = defineEmits(['change:showTipsImg']);
const userName = ref(''); // 账号
const password = ref(''); // 密码
const onSubmit = async (data) => {
  console.log('submit', data, props.checked);
  // 未勾选 用户协议和隐私协议
  if (!props.checked) {
    emits('change:showTipsImg', true);
    return false;
  };
  const res = await loginReq({
    userName: data.userName,
    password: CryptoJS.MD5(data.password).toString(),
    code: "",
    uuid: ""
  });
  if (res.code == 200) {
    localStorage.setItem("token", res.token);
    userStore.setNewUserInfo(res.user);
    userStore.setLoginPopup(false);
    refreshStore.setPageRefreshData(true);
    loginToWebSocket();
  }
};
</script>

<style lang="scss" scoped>
.comContent {
  width: 100%;
  margin-top: 41px;
  margin-bottom: 15px;
  :deep(.van-form) {
    width: 100%;
    --van-cell-group-inset-padding: 0;
    .van-cell-group {
      .van-cell::before {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: var(--van-padding-md);
        bottom: 0;
        left: var(--van-padding-md);
        border-bottom: 1px solid var(--van-cell-border-color);
        transform: scaleY(.5);
      }
    }
  }
  .footerBtn {
    margin-top: 16px;
    .van-button--square {
      border-radius: 6px;
    }
  }
}
</style>
